import {AppConfig} from "./config"

const Endpoints = {
    financial: {
        generateBankBillet: AppConfig.nm_api.baseUrlOld + 'bankbillet/regenerate-bankbillet',
        getInvoiceBankBillet: AppConfig.nm_api.baseUrl + 'financial/invoicebankbillets',
    },

    admin: {
        customerSchema: `${AppConfig.nm_api.baseUrl}validate-schema`,
        getSystemParameters: AppConfig.nm_api.baseUrl + 'systemparameters',
        login: AppConfig.nm_api.baseUrl + 'login',
    },

    file: {
        save: AppConfig.nm_api.baseUrlOld + 'file/save',
        search: AppConfig.nm_api.baseUrlOld + 'file/search',
    },

    person: {
        search: AppConfig.nm_api.baseUrlOld + 'person/search',
        save: AppConfig.nm_api.baseUrlOld + 'person/save',
        recoverPassword: AppConfig.nm_api.baseUrlOld + 'person/recover-password',
        addContact: AppConfig.nm_api.baseUrlOld + 'contact/add',
    },

    systemConfig: {
        getSystemConfig: AppConfig.nm_api.baseUrl + 'systemparameters/get',
        save: AppConfig.nm_api.baseUrl + 'systemparameters/save',
    },

    product: {
        search: AppConfig.nm_api.baseUrl + 'products/search',
        get: AppConfig.nm_api.baseUrl + 'products/get'
    },

    release: {
        search: AppConfig.nm_api.baseUrl + 'releases/search',
        get: AppConfig.nm_api.baseUrl + 'releases/get',
        oldSearch: AppConfig.nm_api.baseUrlOld + 'productrelease/search',
        getOld: AppConfig.nm_api.baseUrlOld + 'productrelease/get',
        coursePersonList: AppConfig.nm_api.baseUrlOld + 'productrelease/course-person-list',
        certificate: AppConfig.nm_api.baseUrlOld + 'productrelease/generate-certificate',
    },

    invoiceAccount: {
        search: AppConfig.nm_api.baseUrlOld + 'invoiceaccount/search',
        get: AppConfig.nm_api.baseUrlOld + 'invoiceaccount/get'
    },

    account: {
        get: AppConfig.nm_api.baseUrlOld + 'account/get'
    },

    ead: {
        user: {
            search: AppConfig.nm_api.baseUrlOld + 'user/search',
            progress: AppConfig.nm_api.baseUrlOld + 'user/progress'
        },
        module: {
            search: AppConfig.nm_api.baseUrlOld + 'module/searchSimple'
        },
        userTrack: {
            search: AppConfig.nm_api.baseUrlOld + 'usertrack/searchSimple',
            save: AppConfig.nm_api.baseUrlOld + 'usertrack/save'
        },
        forum: {
            search: AppConfig.nm_api.baseUrlOld + 'forum/search'
        },
        forumTopic: {
            tutor: AppConfig.nm_api.baseUrlOld + 'forum-topic/tutor',
            get: AppConfig.nm_api.baseUrlOld + 'forum-topic/get',
            save: AppConfig.nm_api.baseUrlOld + 'forum/save-topic'
        },
        forumPosts: {
            search: AppConfig.nm_api.baseUrlOld + 'forumpost/search',
            save: AppConfig.nm_api.baseUrlOld + 'forumpost/save'
        },
        userForm: {
            get: AppConfig.nm_api.baseUrlOld + 'userform/search',
            consolidate: AppConfig.nm_api.baseUrlOld + 'userform/consolidateformdata'
        },
        userAnswer: {
            save: AppConfig.nm_api.baseUrlOld + "useranswer/save",
            search: AppConfig.nm_api.baseUrlOld + "useranswer/search"
        }
    },

    sale: {
        validateVoucher: AppConfig.nm_api.baseUrlOld + "voucher/validate",
        sell: AppConfig.nm_api.baseUrlOld + "onlinesale/sellSimple",
        executePayPal: AppConfig.nm_api.baseUrlOld + "invoiceaccount/executePayPalPayment",
    },
}

export default Endpoints



// WEBPACK FOOTER //
// ./src/config/endpoints.js